import React from 'react'
import Accordion from "react-bootstrap/Accordion";
import RiskRates from "../Home/components/RiskRates/RiskRates";
import Timeline from "assets/images/temp/Timeline-Widget.svg";
import Africa from "assets/images/location/Africa.svg";
import Asia from "assets/images/location/Asia.svg";
import Australia from "assets/images/location/Australia.svg";
import Carribean from "assets/images/location/Carribean.svg";
import CentralAmerica from "assets/images/location/CentralAmerica.svg";
import Europe from "assets/images/location/Europe.svg";
import NorthAmerica from "assets/images/location/NorthAmerica.svg";
import SouthAmerica from "assets/images/location/SouthAmerica.svg";

import styles from "./RiskUniverse.module.scss";
import DateRange from 'components/DateRange/DateRange';

export default function RiskUniverse() {

  const locations = [
    {
      img: Africa,
      name: "Africa",
    },
    {
      img: Asia,
      name: "Asia",
    },
    {
      img: Australia,
      name: "Australia",
    },
    {
      img: Carribean,
      name: "Carribean",
    },
    {
      img: CentralAmerica,
      name: "Central America",
    },
    {
      img: Europe,
      name: "Europe",
    },
    {
      img: NorthAmerica,
      name: "North America",
    },
    {
      img: SouthAmerica,
      name: "South America",
    },
  ];

  const riskGroups = [
    {
      name: "Cyber",
      icon: "icon-globe",
    },
    {
      name: "Environmental",
      icon: "icon-sun",
    },
    {
      name: "Finance",
      icon: "icon-dollar-sign",
    },
    {
      name: "Fraud",
      icon: "icon-shield-off",
    },
    {
      name: "Human Resources",
      icon: "icon-users",
    },
    {
      name: "Operations",
      icon: "icon-hexagon",
    },
    {
      name: "Regulatory",
      icon: "icon-columns",
    },
    {
      name: "Tax",
      icon: "icon-tag",
    },
  ];

  return (
    <>
      {/* header */}
      <div className="pv-4 ph-3">
        <h3 className="widget-title">Risk Universe</h3>
        <h6 className="fw-300">
          Select items below to filter your information
        </h6>
      </div>
      {/* Header */}

      <div className={styles.riskUniverse}>
        <Accordion
          defaultActiveKey={["DateRange", "Locations", "RiskGroups"]}
          alwaysOpen
        >
          {/* Date Range */}
          <Accordion.Item eventKey="DateRange">
            <Accordion.Header>Date Range</Accordion.Header>
            <Accordion.Body>
              <DateRange />
            </Accordion.Body>
          </Accordion.Item>

          {/* Location */}
          <Accordion.Item eventKey="Locations">
            <Accordion.Header>Locations</Accordion.Header>
            <Accordion.Body>
              <div className="row">
                {locations.map((location) => (
                  <div key={location.name} className="col-3 mb-4 cp">
                    <img
                      src={location.img}
                      alt={location.name}
                      className="fw"
                    />
                    <h6 className="text-gray-400 text-7s mt-3">
                      {location.name}
                    </h6>
                  </div>
                ))}
              </div>
            </Accordion.Body>
          </Accordion.Item>

          {/* Risk Group */}
          <Accordion.Item eventKey="RiskGroups">
            <Accordion.Header>Risk Groups</Accordion.Header>
            <Accordion.Body>
              {/* riskGroups */}
              <div className="row">
                {riskGroups.map((riskGroup) => (
                  <div key={riskGroup.name} className="col-3 mb-4 cp">
                    <div className={styles.box}>
                      <div className={styles.badge}>
                        <i className={riskGroup.icon}></i>
                      </div>
                    </div>
                    <h6 className="text-gray-400 text-7s mt-3">
                      {riskGroup.name}
                    </h6>
                  </div>
                ))}
              </div>
            </Accordion.Body>
          </Accordion.Item>

          {/* Scenarios */}
          <Accordion.Item eventKey="Scenarios">
            <Accordion.Header>Scenarios</Accordion.Header>
            <Accordion.Body>
              <div className="text-uppercase">
                Add new vendor. Close down shope, etc
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>

      {/* <div className="row">
        <div className="col-md-6">
          <RiskRates title="Global" label="LOW INCREASING" />
        </div>
        <div className="col-md-6">
          <RiskRates title="Cyber" label="MEDIUM INCREASING" />
        </div>
        <div className="col-md-6"></div>
      </div> */}
    </>
  );
}
